import React from 'react'
import HeroImage1 from '../images/hero-images/banner-standards-1.jpg'
import HeroImage2 from '../images/hero-images/banner-standards-2.jpg'
import HeroImage3 from '../images/hero-images/banner-standards-3.jpg'


const slides = [
    {
        id: 1,
        image: HeroImage1,
        mainText: 'Hold yourself responsible for a higher <br /> <span>standard than anybody else expects of you.</span>',
        subText: '',
       
    },
    {
        id: 2,
        image: HeroImage2,
        mainText: 'Without standards, there can be no <br /> <span>improvement</span>',
        subText: ''
    },
    {
        id: 3,
        image: HeroImage3,
        mainText: 'Without guidance, there are no standards. <br /> <span>Without standards, there is no consistency</span>',
        subText: '',
    }
  
   
    
]

const HeroSlides = () => {

    return (
        <div className="hero-wrap" id="sec1" data-scrollax-parent="true">
            <div className="slider-carousel-wrap full-height fullscreen-slider-wrap">
                <div className="fullscreen-slider full-height cur_carousel-slider-container fl-wrap" data-slick='{"autoplay": true, "autoplaySpeed": 4000 , "pauseOnHover": false}'>
                {slides.map(slide => (
                    <div key={slide.image} className="fullscreen-slider-item full-height fl-wrap">
                        <div className="bg par-elem hero-bg"  data-bg={slide.image}></div>
                        <div className="overlay"></div>
                        <div className="half-hero-wrap">
                            <h1 dangerouslySetInnerHTML={{ __html: slide.mainText }}></h1>
                        
                            <div className="clearfix"></div>
                            {/* <a href={slide.action.link} className="custom-scroll-link btn float-btn flat-btn color-btn mar-top">Let's Start</a> */}
                        </div>
                    </div>
                ))}
                </div>
                <div className="sp-cont   sp-cont-prev"><i className="fal fa-arrow-left"></i></div>
                <div className="sp-cont   sp-cont-next"><i className="fal fa-arrow-right"></i></div>
                <div className="fullscreenslider-counter"></div>
            </div>
            <div className="hero-decor-numb">
                <span>6.9149106  </span><span>79.9105932 </span>
                <a href="https://g.page/PragICTS?share" target="_blank" className="hero-decor-numb-tooltip">Based In Colombo, Sri Lanka</a>
            </div>
        </div>
    )
}

export default HeroSlides
